import { blueGrey, green } from "@material-ui/core/colors";
// import "typeface-roboto";

const theme = {
  palette: {
    primary: { main: blueGrey[900], color: blueGrey },
    secondary: { main: green[500], color: green },
    transparent: "rgba(255,255,255,0.1)",
    white: "#F6F6F6",
    white70: "rgba(246,246,246,0.7)",
    textBox: "#EADBC4"
  },
  typography: {
    useNextVariants: true
  },
  dialog: {
    backgroundColor: "#F6F6F6",
    margin: 30,
    borderRadius: 10
  },
  overrides: {
    MUIDataTable: {
      responsiveScroll: { maxHeight: 700 }
    },
    MuiTableCell: {
      root: {
        padding: 5
      }
    },
    MuiPaper: {
      root: { backgroundColor: "none" },
      rounded: { borderRadius: 0 },
      elevation1: { boxShadow: "none" },
      elevation4: { boxShadow: "none" }
    },
    MuiPopover: {
      paper: { backgroundColor: "#F6F6F6" }
    },
    MuiDialog: {
      paper: { backgroundColor: "#F6F6F6" }
    },
    MuiCard: {
      root: {
        margin: 0
      }
    },
    MuiCardHeader: {
      root: { backgroundColor: "rgba(255,255,255,0.1)" }
    },
    MuiCardContent: {
      root: { padding: "0 !important" }
    },
    MuiButton: {
      root: {
        margin: 5
      }
    },
    MuiTypography: {
      caption: {
        paddingLeft: 5
      },
      h6: {
        paddingLeft: 10
      }
    },
    MuiPrivateTabIndicator: {
      root: {
        height: 4
      }
    },
    MuiTab: {
      labelIcon: {
        minHeight: 0,
        paddingTop: 4
      },
      wrapper: {
        color: "white"
      },
      textColorInherit: {
        opacity: 1
      }
    }
  }
};

export default theme;
